import "./ZoomControl.scss";
import { ReactComponent as Minus } from "./../../assets/images/minus.svg";
import { ReactComponent as Plus } from "./../../assets/images/plus.svg";
import { InputRange } from "../InputRange";

export function ZoomControl({
	value,
	setValue,
	minScale,
	maxScale,
	modalOpen,
	delay = 0.5,
	duration = 2,
}) {
	const handleValueChange = (e) => {
		setValue(parseFloat(e.target.value));
	};

	const handleMinusClick = () => {
		setValue(value - 0.1);
	};

	const handlePlusClick = () => {
		setValue(value + 0.1);
	};

	return (
		<div
			className={`zoom-control ${modalOpen ? "zoom-control--modal-open" : ""}`}
			style={{ "--delay": `${delay}s`, "--duration": `${duration}s` }}>
			<div className="zoom-control__inner">
				<button onClick={handleMinusClick}>
					<Minus />
				</button>
				<InputRange
					min={minScale}
					max={maxScale}
					value={value}
					step="any"
					onChange={handleValueChange}
				/>
				<button onClick={handlePlusClick}>
					<Plus />
				</button>
			</div>
		</div>
	);
}
